import React from "react";
export default function Banner() {
    return (
        <div id="home" className="banner" >
            <h1 className="banner-name" ><span className="hi">Hi,</span> I am Hariom Kourav</h1>
            <h1 className="banner-pos">A Front-end Developer</h1>
            <p>Get ready to turn ideas into reality</p>
            <button className="btn1 btn">Hire Me</button>
            <button className="btn2 btn">Get resume</button>
        </div>
    );
}